import axios from "axios";
import router from "../router";

const http = axios.create({
  // baseURL: import.meta.env.VITE_BASE_URL,
  baseURL: import.meta.env.VITE_BASE_URL_PRODUCTION,
  timeout: 60000,
});

const token_prefix = localStorage.getItem("token_prefix");

http.interceptors.request.use(
  (config) => {
    config.headers["Authorization"] =
      (token_prefix ? token_prefix : "Bearer ") +
      (localStorage.getItem("token") ? localStorage.getItem("token") : "");
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  (response) => {
    if (response.status !== 200) {
      return Promise.reject(response);
    } else {
      return Promise.resolve(response);
    }
  },
  (error) => {
    let response = error.response;

    if (response && response.status == 401) {
      router.push("/login");
    }
    return Promise.reject(response);
  }
);

export default http;
